import { OrdersService } from '../../../services/OrdersService';
import { Order } from '../../../types';

export const STATUS_MESSAGE_ROW_CLASS =
    'flex min-h-[20px] items-center gap-2 text-sm';

export type StatusNoticeTone = {
    container: string;
    text: string;
    link: string;
};

const STATUS_NOTICE_TONE_BY_VARIANT: Record<string, StatusNoticeTone> = {
    success: {
        container: 'border-green-200 bg-green-50 dark:border-green-800/50 dark:bg-green-500/10',
        text: 'text-green-800 dark:text-green-300',
        link: 'text-green-700 hover:text-green-900 dark:text-green-300 dark:hover:text-green-200',
    },
    info: {
        container: 'border-blue-200 bg-blue-50 dark:border-blue-800/50 dark:bg-blue-500/10',
        text: 'text-blue-800 dark:text-blue-300',
        link: 'text-blue-700 hover:text-blue-900 dark:text-blue-300 dark:hover:text-blue-200',
    },
    warning: {
        container: 'border-amber-200 bg-amber-50 dark:border-amber-800/50 dark:bg-amber-500/10',
        text: 'text-amber-800 dark:text-amber-300',
        link: 'text-amber-700 hover:text-amber-900 dark:text-amber-300 dark:hover:text-amber-200',
    },
    destructive: {
        container: 'border-red-200 bg-red-50 dark:border-red-800/50 dark:bg-red-500/10',
        text: 'text-red-800 dark:text-red-300',
        link: 'text-red-700 hover:text-red-900 dark:text-red-300 dark:hover:text-red-200',
    },
    neutral: {
        container: 'border-slate-200 bg-slate-100 dark:border-slate-700 dark:bg-slate-800/60',
        text: 'text-slate-700 dark:text-slate-300',
        link: 'text-slate-700 hover:text-slate-900 dark:text-slate-300 dark:hover:text-slate-100',
    },
    secondary: {
        container: 'border-slate-200 bg-slate-100 dark:border-slate-700 dark:bg-slate-800/60',
        text: 'text-slate-700 dark:text-slate-300',
        link: 'text-slate-700 hover:text-slate-900 dark:text-slate-300 dark:hover:text-slate-100',
    },
    outline: {
        container: 'border-slate-200 bg-slate-50 dark:border-slate-700 dark:bg-slate-900/60',
        text: 'text-slate-700 dark:text-slate-300',
        link: 'text-slate-700 hover:text-slate-900 dark:text-slate-300 dark:hover:text-slate-100',
    },
};

export function getStatusNoticeTone(order: Order): StatusNoticeTone {
    const variant = OrdersService.getStatusBadgeVariant(
        order.status,
        order.delivery,
    );

    return (
        STATUS_NOTICE_TONE_BY_VARIANT[variant] ||
        STATUS_NOTICE_TONE_BY_VARIANT.outline
    );
}
